import { apiRequest } from '../apiHelper';
import ROUTES from './index.constant';

export const getUserTenantRoles = async (peakV3Id: string) => {
    return apiRequest(`${ROUTES.USER_TENANT_ROLES}/${peakV3Id}`, {
        method: 'GET',
    });
};

export const getCustomTenantRoles = async (tenantId: string | number) => {
    const searchParams = new URLSearchParams({
        dropdown: 'true',
    });

    return apiRequest(
        `${ROUTES.CUSTOM_TENANT_ROLES}/${tenantId}?${searchParams.toString()}`,
        {
            method: 'GET',
        }
    );
};

export const updateUserCustomRoles = async (
    peakV3Id: string,
    tenantRoleIds: number[]
) => {
    return apiRequest(`${ROUTES.USER_TENANT_ROLES}/${peakV3Id}`, {
        method: 'POST',
        body: {"tenantRoleIds": tenantRoleIds },
    });
};